var _a, _b;
/**
 * Check if window is available
 * @internal
 */
export const isSSR = typeof window === 'undefined';
export const isBrowser = !isSSR;
export const isPointingDeviceCoarse = isBrowser && ((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(pointer: coarse)').matches);
export const supportsHover = isBrowser && !((_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, '(hover: none)').matches);
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
let passiveSupported = false;
try {
    const options = {
        get passive() {
            passiveSupported = true;
            return false;
        },
    };
    // @ts-ignore
    window.addEventListener('test', null, options);
    // @ts-ignore
    window.removeEventListener('test', null, options);
}
catch (err) {
    passiveSupported = false;
}
export const hasPassiveSupport = passiveSupported;
export const passiveEventOptions = passiveSupported ? { passive: true } : false;
/**
 * Calculate the width the scrollbar takes up
 * If this is false we assume the scrollbar is on top of the page like on most touch devices and default on macOS
 */
export const hasScrollbarWidth = (() => {
    if (!isBrowser) {
        return true;
    }
    const inner = document.createElement('div');
    inner.style.cssText = `
    width: 100%;
    height: 200px;
  `;
    const outer = document.createElement('div');
    outer.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    visibility: hidden;
    width: 200px;
    height: 150px;
    overflow: hidden;
  `;
    outer.appendChild(inner);
    document.body.appendChild(outer);
    // Width without scrollbar
    const innerWidth = inner.offsetWidth;
    // Width with scrollbar forced
    outer.style.overflow = 'scroll';
    const outerWidth = outer.clientWidth;
    document.body.removeChild(outer);
    return innerWidth - outerWidth > 0;
})();
